export const TERMS_OF_SERVICE_URL = ' https://buttercup-coral-e9a.notion.site/9e7c367b66524429b1dee93c05d2929b?pvs=4';

export const PRIVACY_POLICY_URL = 'https://buttercup-coral-e9a.notion.site/5db1eda2ab184b6c9f860103119b2d17?pvs=4';

export const ABOUT_US_URL = 'https://buttercup-coral-e9a.notion.site/About-Us-80904015830149b2995ecedc7ad75311?pvs=4';

export const APPLY_SERVICE_URL = 'https://tally.so/r/w5EgKZ';

export const APPLY_MANAGER_URL = 'https://tally.so/r/mV4pR6';

export const ABOUT_CHECKMATE_URL =
  'https://buttercup-coral-e9a.notion.site/About-CheckmateKorea-1e4c00e5608680048c69fe0ac3b7da11?pvs=4';

export const WHY_CHECKMATE_URL =
  'https://buttercup-coral-e9a.notion.site/Why-CheckmateKorea-1e4c00e56086806599eefb938f144389?pvs=4';

export const MEMBERSHIP_URL =
  'https://buttercup-coral-e9a.notion.site/Checkmate-Membership-1d8c00e5608680c4b530ea0b86e3fff8';

export const EVENTS_URL = 'https://buttercup-coral-e9a.notion.site/Events-Benefits-1d3c00e5608680b4868ef5d3f5155bdf';

export const HELP_CENTER_URL =
  'https://buttercup-coral-e9a.notion.site/Help-Center-a65dec1c44ca44958a2d192d5119017e?pvs=4';

export const ONLINE_SALES_URL = 'http://www.ftc.go.kr/bizCommPop.do?wrkr_no=5868703123';

export const CHECKMATE_PLUS_URL =
  'https://buttercup-coral-e9a.notion.site/Checkmate-Plus-1d3c00e5608680b4868ef5d3f5155bdf';

export const CHECKMATE_MEMBERSHIP_URL =
  'https://buttercup-coral-e9a.notion.site/Checkmate-Membership-1d8c00e5608680c4b530ea0b86e3fff8';

export const CHECK_WITH_YOU_URL = 'https://tally.so/r/w5EgKZ';

export const CONTRACT_ACCOMPANIMENT_URL = 'https://tally.so/r/mV4pR6';

// Track B(콘텐츠 인증 리워드) 신청 Tally 폼.
// 폼에는 user_id hidden 필드가 있으며, 버튼이 쿼리 파라미터로 회원번호를 자동 첨부한다.
export const CONTENT_REWARD_FORM_URL = 'https://tally.so/r/ob1GYe';

// 웰컴 랜딩(/welcome) 가입 혜택 — 한국생활 가이드 노션 페이지
export const KOREA_LIFE_GUIDE_URL =
  'https://buttercup-coral-e9a.notion.site/Free-Guide-to-Life-in-Korea-28ec00e5608680f893edefd359847e0e';
